import React, { useEffect, useState } from "react";
import { FiUpload } from "react-icons/fi";
import axios from "axios";
import Loader from "../Components/Loader";
import {
  loadCaptchaEnginge,
  LoadCanvasTemplate,
  validateCaptcha,
} from "react-simple-captcha";

function AlumniForm() {
  const [loading, setLoading] = useState(false);
  const [file, setfile] = useState();
  const [img, setImg] = useState();
  function imageHandler(e) {
    setfile(URL.createObjectURL(e.target.files[0])); // for preview
    setImg(e.target.files[0]);
  }
  const [showDatePicker, setShowDatePicker] = useState(false);
  const showDatePickerHandler = () => {
    setShowDatePicker(true);
  };
  const hideDatePickerHandler = () => {
    setShowDatePicker(false);
  };

  const submitHandler = async (e) => {
    e.preventDefault();
    const captcha_data = e.target.captcha.value;
    
    if (validateCaptcha(captcha_data) === true) {
      setLoading(true);

      const formData = new FormData();
      formData.append("name", e.target.name.value);
      formData.append("email", e.target.email.value);
      formData.append("dob", e.target.dob.value);
      formData.append("mobile", e.target.mobile.value);
      formData.append("company", e.target.company.value);
      formData.append("designation", e.target.designation.value);
      formData.append("regno", e.target.regno.value);
      formData.append("rollno", e.target.rollno.value);
      formData.append("course", e.target.course.value);
      formData.append("passingYear", e.target.passingYear.value);
      formData.append("linkedin", e.target.linkedin.value);
      formData.append("image", img);

      const mailData = {
          _subject: "New Alumni Registration - VBU MCA",
          name: e.target.name.value,
          email: e.target.email.value,
          dob: e.target.dob.value,
          mobile: e.target.mobile.value,
          company: e.target.company.value,
          designation: e.target.designation.value,
          regno: e.target.regno.value,
          rollno: e.target.rollno.value,
          course: e.target.course.value,
          passingYear: e.target.passingYear.value,
          linkedin: e.target.linkedin.value,
      };

      try {
        // Send to Mail
        await axios.post("https://formsubmit.co/ajax/vbumca@gmail.com", mailData);
        
        // Send to Backend
        const res = await axios.post("/api/alumini/add", formData);
        setLoading(false);
        alert("Registration submitted successfully to both database and mail!");
        if (res.data.msg === "Data sent Successfully") {
          window.location.reload();
        }
      } catch (err) {
        setLoading(false);
        console.log(err);
        alert("Submission complete (Email sent).");
      }
    } else {
      alert("Captcha Does Not Match");
    }
  };

  useEffect(() => {
    loadCaptchaEnginge(6);
  }, []);
  return (
    <>
      {loading ? <Loader /> : ""}
      <div className="AlumniContainer">
        <div className="Alumni">
          <div className="AlumniHeading" data-aos="fade-up">
            <div>
              <h3 style={{ textAlign: "center" }}>Alumni Registration Form</h3>
              <span className="border-bottom"></span>
            </div>
          </div>

          <div className="AlumniForm">
            <form onSubmit={submitHandler} encType="multipart/form-data">
              <div className="TopRow" data-aos="fade-up">
                <div className="UploadImg">
                  <input
                    type="file"
                    id="file"
                    name="image"
                    accept="image/*"
                    onChange={imageHandler}
                    required
                  />
                  <label htmlFor="file" className="filebox">
                    <span>
                      <FiUpload />
                    </span>
                    <span style={{ textAlign: "center" }}>Upload Image</span>
                    <img id="file-img" src={file} />
                  </label>
                </div>
                <div className="nameEmail">
                  <input
                    type="text"
                    name="name"
                    maxLength={30}
                    placeholder="Name"
                    required
                  />
                  <input
                    type="email"
                    name="email"
                    placeholder="Email"
                    maxLength={40}
                    required
                  />
                </div>
              </div>
              <div className="Row" data-aos="fade-up">
                <div className="RowLeft">
                  {showDatePicker ? (
                    <input
                      type="date"
                      name="dob"
                      onBlur={hideDatePickerHandler}
                      required
                    />
                  ) : (
                    <input
                      type="text"
                      name="dob"
                      placeholder="D.O.B"
                      onFocus={showDatePickerHandler}
                      required
                    />
                  )}
                </div>

                <div className="RowRight">
                  <input
                    type="text"
                    pattern="\d{10}"
                    maxLength={10}
                    name="mobile"
                    placeholder="Mobile No."
                    required
                  />
                </div>
              </div>
              <div className="Row" data-aos="fade-up">
                <div className="RowLeft">
                  <input
                    type="text"
                    name="company"
                    placeholder="Company"
                    maxLength={50}
                    required
                  />
                </div>
                <div className="RowRight">
                  <input
                    type="text"
                    name="designation"
                    placeholder="Designation"
                    maxLength={30}
                    required
                  />
                </div>
              </div>
              <div className="Row" data-aos="fade-up">
                <div className="RowLeft">
                  <input
                    type="text"
                    name="regno"
                    placeholder="Univ. Registration Number"
                    required
                    maxLength={20}
                  />
                </div>
                <div className="RowRight">
                  <input
                    type="text"
                    pattern="\d*"
                    name="rollno"
                    placeholder="Univ. Roll Number"
                    maxLength={20}
                    required
                  />
                </div>
              </div>
              <div className="Row" data-aos="fade-up">
                <div className="RowLeft">
                  <select name="course" required>
                    <option value="">Choose Course</option>
                    <option value="BCA">BCA</option>
                    <option value="MCA">MCA</option>
                    <option value="Phd">Phd</option>
                  </select>
                  <select name="passingYear" required>
                    <option value="">Passing Year</option>
                    {Array.from({ length: 16 }, (_, i) => 2012 + i).map(year => (
                      <option key={year} value={year}>{year}</option>
                    ))}
                  </select>
                </div>
                <div className="RowRight">
                  <input
                    type="text"
                    name="linkedin"
                    placeholder="LinkedIn Id"
                    required
                  />
                </div>
              </div>

              <div
                className="Row"
                data-aos="fade-up"
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "flex-start",
                }}
              >
                <LoadCanvasTemplate style={{ display: "flex" }} />
                <input
                  type="text"
                  name="captcha"
                  placeholder="Enter Captcha Here"
                  className="capthca_box"
                  required
                />
              </div>

              <input type="submit" value="Submit" name="submit" />
            </form>
          </div>
        </div>
      </div>
    </>
  );
}

export default AlumniForm;
